import { render, staticRenderFns } from "./ListaProtocolos.vue?vue&type=template&id=0028c02c&"
import script from "./ListaProtocolos.vue?vue&type=script&lang=js&"
export * from "./ListaProtocolos.vue?vue&type=script&lang=js&"
import style0 from "./ListaProtocolos.vue?vue&type=style&index=0&id=0028c02c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports